export default __webpack_public_path__ + "static/media/singleProduct_Banner.bebd7555.jpg";